<template>
  <div class="login-bga" v-show="isTips">
    <!-- 登录 -->
    <div class="login-boxs" v-show="islogin">
      <div><a class="login-close" @click="closeBtn"></a></div>
      <a-input :placeholder="$t('login_请输入用户名或手机号码')" class="login-input" style="margin-top:71px;" v-model.trim="uesrName" />
      <a-input-password :placeholder="$t('common_home_enter_login_password')" class="login-input" style="margin-top:22px;" v-model.trim="pwNum" @keyup.13="loginUsPassBtn" />
      <a-input :placeholder="$t('login_请输入客户代码')" class="login-input" style="margin-top:22px;" v-show="isCustomer" v-model.trim="customer" />
      <div>
        <a-button
          type="primary"
          class="btn"
          @click="loginUsPassBtn"
          :loading="isLoading"
        >
        {{!isLoading?$t('common_login'): $t('login_登录中') + '...'}}
        </a-button>
      </div>
      <div class="more-option">
        <span @click="regis">{{$t('common_login_register')}}</span>
        <span @click="ON_FORGOT">{{$t('common_login_forget_password')}}?</span>
      </div>
      <div class="login-page__erp" @click="customerBtn"><i class="open-icon-ERP" />{{isCustomer ? $t('common_login_return_user_login'): $t('common_login_erp1_cust_login')}}</div>
    </div>

    <!-- 注册 -->
    <div class="login-boxs" v-show="isRegister">
      <div><a class="login-close" @click="closeBtn"></a></div>
      <a-input
       :placeholder="$t('common_home_enter_mobile')"
       class="login-input"
       style="margin-top:51px;"
       @keyup="phoneNum = phoneNum.replace(/[^\d]/g, '')"
       :maxLength="Number(num)" v-model="phoneNum"
      >
        <a-select
          slot="addonBefore"
          :value="countryCode | disCountryCode"
          style="width: 100px;font-size:14px;"
          :dropdownMatchSelectWidth="false"
          :dropdownStyle="{width:'360px'}"
          @select="changeInternational"
        >
          <a-select-option
            v-for="(item, index) in countryCodeList"
            :value="item.id"
            :key="item.phonecode+index"
          >
            <div slot="div" style="display:flex;justify-content:space-between;">
              <span slot="span">{{item.name_zh}}</span>
              <span slot="span">+ {{item.phonecode}}</span>
            </div>
          </a-select-option>
        </a-select>
      </a-input>
      <div class="forget-very">
        <a-input :placeholder="$t('login_请输入右侧验证码')" class="login-input" style="margin-top:20px;" v-model.trim="veryCodeInput" />
        <img class="forget-avatar" :src="bestCode" @click="veryCodeAvatar" alt="" />
      </div>
      <div class="forget-message">
        <a-input
          type="text"
          :maxLength="6"
          :placeholder="$t('common_home_enter_new_verCode')"
          class="login-input"
          style="margin-top:20px;"
          v-model="veryCodePhone"
        >
          <span slot="suffix">
            <a-spin :spinning="isCodeLoading && show">
              <i class="forget-veryBtn" v-show="show" @click="toCaptcha">{{$t('common_btn_send_ver')}}</i>
              <i class="forget-veryBtn" v-show="!show">{{count}} s</i>
            </a-spin>
          </span>
        </a-input>
      </div>
      <a-input :placeholder="$t('childAct_请输入邮箱')" class="login-input" style="margin-top:22px;" v-model="email" />
      <a-input-password :placeholder="$t('common_home_enter_email_address_format_numbers')" autocomplete="new-password" class="login-input" style="margin-top:22px;" v-model="pwNum" />
      <a-input-password :placeholder="$t('common_home_enter_email_address_format_again')" autocomplete="new-password" class="login-input" style="margin-top:22px;" v-model="morepwNum" />
      <a-row style="margin-top: 22px;">
        <a-cascader
          v-model="addressCode"
          class="login-input cascader"
          style="background-color: transparent; font-size: 14px;"
          popupPlacement="topLeft"
          :options="cascaderOptions"
          :load-data="loadData"
          :placeholder="$t('common_globalcomp_select_area')"
          change-on-select
          @change="onChangeCascader"
        >
        </a-cascader>
      </a-row>
      <div class="login-agreement">
        <a-checkbox :checked="agreement" @change="onChange" style="font-size:12px;">{{$t('common_login_阅读并同意')}}</a-checkbox>
        <span><router-link to="/Agreement" tag="a" target="_blank">《{{$t('common_login_ServiceAgreement')}}》</router-link>{{$t('common_conj_and')}}<router-link to="/PolicyModal" tag="a" target="_blank">《{{$t('common_login_PrivacyPolicy')}}》</router-link></span>
      </div>
      <div>
        <a-button type="primary" class="btn" :loading="isLoading" @click="loginRegBtn">
        {{$t('common_login_register')}}
        </a-button>
      </div>
      <div class="more-option">
        <span @click="switChGolin">{{$t('common_login')}}</span>
        <span @click="ON_FORGOT">{{$t('common_login_forget_password')}}?</span>
      </div>
    </div>

    <!-- 注册成功 -->
    <div class="login-boxs seccess-box" v-show="isRegSeccess">
      <div><a class="login-close" @click="OFF_LOGIN()"></a></div>
      <img src="../assets/o1.png" alt="" />
      <div class="seccess-happed">{{$t('login_恭喜您注册成功')}}</div>
      <div class="seccess-text">{{$t('login_请妥善保管您的账户信息')}}</div>
      <div @click="OFF_LOGIN()">
        <div class="reg-btn" @click="$router.go(0)" tag="div">{{$t('login_进入首页')}}</div>
        <router-link class="reg-work-btn" to="/work/credentials" tag="div">{{$t('login_进入工作台')}}</router-link>
      </div>
    </div>

    <Forget-pass-world />
  </div>
</template>

<script>
// @ is an alias to /src
import ForgetPassWorld from '@/components/ForgetPassWorld.vue'
import { mapState, mapMutations } from 'vuex'
import {
  loginUser,
  LoginCodeAvatar,
  LoginCheckImgCode,
  Register,
  SsoGetCityInfo,
  PhoneCodeInterface,
  TransformLogin
} from '@/api/login'
import { openNotificationWithIcon, debounce } from '@/utils/util'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { Cascader } from 'ant-design-vue'
import md5 from 'md5'

export default {
  name: 'isLogin',
  data () {
    return {
      num: 11,
      uesrName: '',
      phoneNum: '',
      veryCodeInput: '',
      veryCodePhone: '',
      agreement: false,
      show: true, // 验证码开关
      count: '',
      timer: '',
      bestCode: '',
      pwNum: '',
      morepwNum: '',
      imgCodeKey: '',
      email: '',
      isLoading: false,
      countryCode: ' 86',
      cascaderOptions: [],
      addressCode: [],
      customer: '',
      isCustomer: false,
      isCodeLoading: false,
      countryCodeList: [
        { name_zh: '中国大陆', numcode: '156', iso: 'CN', name: 'CHINA', nicename: 'China', phonecode: '86', id: '44', sort: '9999', iso3: 'CHN' },
        { name_zh: '中国香港', numcode: '344', iso: 'HK', name: 'HONG KONG', nicename: 'Hong Kong', phonecode: '852', id: '96', sort: '9998', iso3: 'HKG' },
        { name_zh: '中国澳门', numcode: '446', iso: 'MO', name: 'MACAO', nicename: 'Macao', phonecode: '853', id: '125', sort: '9997', iso3: 'MAC' },
        { name_zh: '中国台湾', numcode: '158', iso: 'TW', name: 'TAIWAN, PROVINCE OF CHINA', nicename: 'Taiwan, Province of China', phonecode: '886', id: '208', sort: '9996', iso3: 'TWN' },
        { name_zh: '美国', numcode: '840', iso: 'US', name: 'UNITED STATES', nicename: 'United States', phonecode: '1', id: '226', sort: '9995', iso3: 'USA' },
        { name_zh: '澳大利亚', numcode: '36', iso: 'AU', name: 'AUSTRALIA', nicename: 'Australia', phonecode: '61', id: '13', sort: '9993', iso3: 'AUS' },
        { name_zh: '英国', numcode: '826', iso: 'GB', name: 'UNITED KINGDOM', nicename: 'United Kingdom', phonecode: '44', id: '225', sort: ' 9993', iso3: 'GBR' }
      ]
    }
  },
  components: {
    ForgetPassWorld,
    ACascader: Cascader
  },
  watch: {
    'isRegister' () {
      this.pwNum = ''
      this.uesrName = ''
    }
  },
  filters: {
    disCountryCode (val) {
      return `+ ${val}`
    }
  },
  computed: {
    ...mapState({
      'isTips': state => state.isLogin.isTips,
      'islogin': state => state.isLogin.islogin,
      'isRegister': state => state.isLogin.isRegister,
      'isRegSeccess': state => state.isLogin.isRegSeccess,
      'isBuy': state => state.isLogin.isBuy
    })
  },
  mounted () {
    this.veryCodeAvatar()
    this._SsoGetCityInfo({ cityScope: 'province' })
    this._PhoneCodeInterface()
  },
  methods: {
    ...mapMutations(['OFF_LOGIN', 'ON_LOGIN', 'ON_FORGOT', 'SECCESS_REGISTER', 'SET_IS_CREDENTIALS', 'SET_IS_CHOICE_SUBJECT', 'IS_CALLME']),
    regis () {
      this.ON_LOGIN('agreement')
      this.pwNum = ''
    },
    // erp 登录
    customerBtn () {
      this.isCustomer = !this.isCustomer
      if (!this.isCustomer) {
        this.customer = ''
      }
    },
    getCityFn (type, code) {
      return new Promise((resolve, reject) => {
        const params = {
          cityScope: type, // 'area' : 'city',
          cityCode: code
        }
        SsoGetCityInfo(params).then(res => {
          const { data } = res
          let children = []
          if (data && data.length) {
            data.forEach(item => {
              let itemOpt = {
                value: item.cityCode,
                label: item.cityName
              }
              if (type === 'city') itemOpt.isLeaf = false
              children.push(itemOpt)
            })
          }
          resolve(children)
        })
      })
    },
    // 区号
    _PhoneCodeInterface () {
      PhoneCodeInterface({}).then(({ data }) => { // 区号
        if (!data) return
        this.countryCodeList = JSON.parse(data.result)
      })
        .finally(() => {
          this.countryCode = this.countryCodeList[0].phonecode
        })
    },
    // 区号选择
    changeInternational (val, event) {
      this.countryCodeList.forEach((item) => {
        if (item.id === val) {
          this.countryCode = item.phonecode
        }
      })
    },
    closeBtn () {
      this.OFF_LOGIN()
      this.phoneNum = ''
      this.veryCodeInput = ''
      this.veryCodePhone = ''
      this.email = ''
      this.pwNum = ''
      this.morepwNum = ''
    },
    switChGolin () {
      this.ON_LOGIN('login')
      this.phoneNum = ''
      this.veryCodeInput = ''
      this.veryCodePhone = ''
      this.email = ''
      this.pwNum = ''
      this.morepwNum = ''
    },
    // 登录
    loginUsPassBtn () {
      let {
        uesrName,
        pwNum,
        isCustomer,
        customer
      } = this
      if (uesrName.trim() === '') return openNotificationWithIcon(this.$t('common_home_enter_mobile'))
      if (pwNum.trim() === '') return openNotificationWithIcon(this.$t('authority_account_passwords'))
      if (isCustomer && !customer) return openNotificationWithIcon(this.$t('login_请输入客户代码'))

      this.isLoading = true
      loginUser({
        password: pwNum,
        userName: uesrName,
        systemCode: 'OPEN_API_PORTAL',
        subjectCode: customer.trim()
      }).then(({ code, message, data }) => {
        if (`${code}` === '200') {
          this.$ls.set(ACCESS_TOKEN, data)
          this.$store.dispatch('_SsoGetUserInfo').then((data) => {
            if (this.isBuy) {
              console.log('isBuy')
              TransformLogin({
                targetPlatformCode: 'SSO_SYS_USER'
              }).then(res => {
                window.open(`${process.env.VUE_APP_HOME_URL || '//testnew-home.eccang.com'}/#/company/serve/buy-serve?token=${res.data}`, '_blank')
              })
            }
            const item = {
              subjectId: data.onlineSubjectId,
              companyName: data.onlineSubjectName
            }
            this.$store.dispatch('_SsogetUserRoleMenu', item)
          })
          this.OFF_LOGIN()
        } else if (`${code}` === 'saas.sso.error.code.8000') { // 首次登录，需要去选择企业主体
          console.log('code', `${code}`)
          this.OFF_LOGIN()
          this.SET_IS_CREDENTIALS(true)
          this.SET_IS_CHOICE_SUBJECT(true)
          if (this.$store.state.isLogin.isChoiceSubject === true) {
            this.$store.commit('SET_IS_CHOICE_SUBJECT', false)
          } else {
            this.$store.commit('SET_IS_CHOICE_SUBJECT', true)
          }
          this.$router.push('/work/credentials')
        } else {
          openNotificationWithIcon(message)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    // 注册
    loginRegBtn () {
      const regEmail = /^[._-\w\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      const pwdReg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,16}$/

      if (this.phoneNum.length !== 11 && this.countryCode === '86') return openNotificationWithIcon(this.$t('common_home_user_mobile_phone3'))
      if (this.phoneNum.length === '') return openNotificationWithIcon(`${this.$t('common_home_enter_mobile')}!`)
      if (this.veryCodeInput.length !== 4) return openNotificationWithIcon(`${this.$t('authority_account_four_verCode')}!`)
      if (this.email !== null && this.email !== undefined && this.email !== 'undefined' && this.email !== '' && !regEmail.test(this.email)) {
        openNotificationWithIcon(`${this.$t('common_home_enter_email_address_format_incorrect')}!`)
        return false
      }
      if (!pwdReg.test(this.pwNum)) return openNotificationWithIcon(`${this.$t('common_home_enter_email_address_format_numbers')}!`)

      if (this.veryCodePhone === '') return openNotificationWithIcon(`${this.$t('common_home_enter_new_verCode')}!`)
      if (this.pwNum === '') return openNotificationWithIcon(`${this.$t('authority_account_passwords')}!`)
      if (this.morepwNum === '') return openNotificationWithIcon(`${this.$t('common_home_enter_email_address_format_again')}!`)
      if (this.pwNum !== this.morepwNum) return openNotificationWithIcon(`${this.$t('authority_account_passwords_no')}!`)
      const { addressCode } = this
      if (addressCode.length === 0) {
        return openNotificationWithIcon(`${this.$t('common_globalcomp_select_area')}!`)
      } else if (addressCode.length < 3) {
        return openNotificationWithIcon(this.$t('common_login_ckeck_请选择完整的地区'))
      }
      if (!this.agreement) return openNotificationWithIcon(`${this.$t('authority_account_Agreement')}!`)

      this.isLoading = true
      const data = {
        email: this.email,
        nickName: '',
        phone: this.phoneNum,
        phoneCode: this.countryCode,
        shortMessageCode: this.veryCodePhone,
        password: this.morepwNum,
        systemCode: 'OPEN_API_PORTAL',
        leadProvince: addressCode[0],
        leadCity: addressCode[1],
        leadArea: addressCode[2]
      }
      Register(data).then((res) => {
        if (res.code === '200') {
          this.SECCESS_REGISTER(true)
        } else {
          openNotificationWithIcon(res.message)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    onChange (e) {
      this.agreement = e.target.checked
    },
    // 获取图形验证码
    veryCodeAvatar () {
      debounce(() => {
        LoginCodeAvatar({}).then((res) => {
          this.bestCode = res.data.imgCodeData
          this.imgCodeKey = res.data.imgCodeKey
          // this.veryCode()
        })
      }, 1000)
    },
    // 发送验证码
    toCaptcha () {
      if (this.countryCode === '86' && this.phoneNum.length !== 11) return openNotificationWithIcon(`${this.$t('common_home_user_mobile_phone3')}`)
      if (!this.phoneNum) return openNotificationWithIcon(`${this.$t('common_home_enter_mobile')}`)
      if (this.veryCodeInput.length !== 4) return openNotificationWithIcon(`${this.$t('common_home_user_four_digit')}`)
      if (this.veryCodeInput === '') return openNotificationWithIcon(`${this.$t('common_home_enter_new_verCode')}`)

      this.isCodeLoading = true
      const timestamp = Date.now()
      const signString = timestamp + this.phoneNum + 'bfe87cf3f863da8d'
      const sign = md5(signString)

      console.log(signString, sign)

      LoginCheckImgCode({
        phoneCode: this.countryCode,
        imgCodeKey: this.imgCodeKey,
        imgCode: this.veryCodeInput,
        phone: this.phoneNum,
        systemCode: 'OPEN_API_PORTAL',
        sign,
        timestamp
      }).then(({ code, message }) => {
        if (`${code}` === '200') {
          // this.isTips = false
          this.veryCode()
        } else {
          this.veryCodeAvatar()
          openNotificationWithIcon(message)
        }
      }).finally(() => {
        this.isCodeLoading = false
      })
    },
    // 验证码
    veryCode () {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    onChangeCascader (value) {
      if (value && value.length) {
        this.addressCode = value
      } else {
        this.addressCode = []
      }
    },
    loadData (selectedOptions) {
      const len = selectedOptions.length
      const targetOption = selectedOptions[len - 1]
      targetOption.loading = true

      const params = {
        cityScope: len > 1 ? 'area' : 'city',
        cityCode: targetOption.value
      }
      SsoGetCityInfo(params).then(res => {
        const { data } = res
        targetOption.loading = false
        let children = []
        if (data && data.length) {
          data.forEach(item => {
            let itemOpt = {
              value: item.cityCode,
              label: item.cityName
            }
            if (len === 1) itemOpt.isLeaf = false
            children.push(itemOpt)
          })
          targetOption.children = children
        }
        this.cascaderOptions = [...this.cascaderOptions]
      })
    },
    _SsoGetCityInfo (params) {
      SsoGetCityInfo(params).then(res => {
        const { data } = res
        let optionAry = []
        this.cascaderOptions = []
        if (data && data.length) {
          data.forEach(item => {
            const itemOpt = {
              value: item.cityCode,
              label: item.cityName,
              isLeaf: false
            }
            optionAry.push(itemOpt)
          })
          this.cascaderOptions = optionAry
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.login-bga {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.26);
  z-index: 9;
  color: #fff;
}
.login-boxs {
  text-align: center;
  width:470px;
  // height:351px;
  position: absolute;
  left: 50%;
  top:50%;
  z-index: 99;
  transform:translate(-50%,-50%);
  background:rgba(255,255,255,1);
}
.login-input {
  width:360px;
  height:48px;
}
.login-boxs /deep/ .ant-input  {
  height:48px;
}
.login-close {
  position: absolute;
  right: 18px;
  top: 17px;
  width: 32px;
  height: 32px;
  padding-top: 10px;
}
.login-close:before, .login-close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 16px;
  width: 2px;
  background-color: #999999;
}
.login-close:before {
  transform: rotate(45deg);
}
.login-close:after {
  transform: rotate(-45deg);
}
.btn {
 margin-top: 26px;
 width:360px;
 height:48px;
 font-size:16px;
}
.more-option {
  width: 360px;
  margin: 0 auto;
  margin-top: 23px;
  display: flex;
  margin-bottom: 48px;
  justify-content: space-between;
  align-items: center;
  span {
    cursor: pointer;
    font-weight:400;
    font-size: 12px;
    &:nth-child(1) {
      color: #4978D6;
    }
    &:nth-child(2) {
      color: #4978D6;
    }
  }
}
.login-page__erp {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 22px;
  margin-bottom: 24px;
  font-size: 14px;
  line-height: 1;
  color: #5794FD;
  i {
    margin-right: 5px;
  }
}
.login-agreement {
  text-align: left;
  margin-left: 51px;
  margin-top: 20px;
  font-size:12px;
  cursor: pointer;
  span {
    color: #4978D6;
  }
}
.forget-very {
  position: relative;
  .forget-avatar {
    position: absolute;
    right: 68px;
    top: 26px;
    width: 64px;
    height: 37px;
    background: #ccc;
    cursor: pointer;
    box-shadow: none;
  }
}
.seccess-box {
  width: 343px;
  font-weight:400;
  img {
    margin-top: 81px;
    width: 88px;
    height: 88px;
  }
  .seccess-happed {
    margin-top: 22px;
    font-size:18px;
    color: #282828;
  }
  .seccess-text {
    margin-top: 16px;
    font-size:14px;
    color: #989898;
  }
  .reg-btn {
    cursor: pointer;
    margin: 0 auto;
    margin-top: 16px;
    font-size:16px;
    width:165px;
    height:36px;
    line-height: 36px;
    border-radius: 4px;
    color: #fff;
    background: #4478D6;
  }
  .reg-work-btn {
    margin: 0 auto;
    cursor: pointer;
    font-size:16px;
    width:165px;
    height:36px;
    margin-top: 16px;
    margin-bottom: 83px;
    line-height: 36px;
    border-radius:4px;
    color: #4478D6;
    border:1px solid #4478D6;
  }
}
.forget-message {
  position: relative;
  .forget-veryBtn {
    cursor: pointer;
    // background-color: #daf8eb;
    padding: 14px 16px;
    color: #4478D6;
    font-style:normal
  }
}
.cascader {
  text-align:left;
  /deep/ .ant-cascader-input.ant-input {
    height: 48px;
    line-height: 48px;
  }
}
</style>
